<template lang="pug">
  div(data-testid="exchange-history-list")
    loading(v-if="isLoading" data-testid="-loading")
    template(v-else)
      .row.-bg(v-for="rownum of bootstrapRowCount", :key="rownum")
        .col-xs-4(v-for="(item, index) in getBootstrapSplittedList(rownum)", :key="item.id" data-testid="-exchange-history")
          //p {{index}} {{item.id}} {{(rownum - 1) * 3 + index}}
          .box(data-testid="-box-exchange")
            .box-header.with-border(v-if="editable(item) || deletable(item)")
              .pull-right
                button.btn.btn-xs.btn-primary(v-if="editable(item)", type="button", title="変更", @click.prevent="openEdit(item)" data-testid="-btn-edit")
                  i.fa.fa-pencil
                |
                |
                button.btn.btn-xs.btn-danger(v-if="deletable(item)", type="button", title="削除", @click.prevent="openDelete(item)" data-testid="-btn-delete")
                  i.fa.fa-trash

            .box-body
              exchange-view(v-model="list[getBootstrapRealIndex(rownum, index)]")

            .box-footer.text-right
              router-link(:to="{name: 'box-history-detail', params: {sidPerson, sidBcard: item.sid_bcard}}" data-testid="-link-view-bcard-data") この交換情報の名刺を見る

    p.text-center(v-if="bootstrapRowCount === 0") 名刺交換履歴はありません。

    portal(to="modal")
      form(@submit.prevent="submitEdit")
        app-modal(v-model="modalEdit.isOpen" data-testid="bcard-exchange-edit-modal")
          template(slot="title") 名刺交換履歴の編集
          exchange-form(v-model="modalEdit.value", :is-exchangers-editable="false")
          template(slot="footer" slot-scope="{close}")
            button.btn.btn-primary(type="submit" :disabled="modalEdit.isExec" data-testid="-btn-edit") 変更
            button.btn.btn-default(type="button" @click.prevent="close" data-testid="-btn-cancel") キャンセル

      app-modal(type="danger" v-model="modalDelete.isOpen" data-testid="bcard-exchange-delete-modal")
        template(slot="title") 名刺交換履歴の削除
        h4 こちらの名刺交換履歴を削除します。よろしいですか？
        p.text-danger ※名刺交換履歴がすべて削除されると、その名刺情報も削除されます。
        template(slot="footer" slot-scope="{close}")
          button.btn.btn-danger(type="button" @click.prevent="submitDelete" :disabled="modalDelete.isExec" data-testid="-btn-delete") 削除
          button.btn.btn-default(type="button" @click.prevent="close") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppPagination from '@/components/molecules/AppPagination'
import Loading from '@/components/molecules/Loading'
import ExchangeForm from '@/components/organisms/forms/ExchangeForm'
import ExchangeView from '@/components/organisms/views/ExchangeView'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const ExchangeRepository = RepositoryFactory.get('exchange')
const COL_COUNT = 3

/**
 * $emit('delete')
 */
export default {
  name: 'ExchangeHistoryList',
  components: { AppModal, AppPagination, Loading, ExchangeForm, ExchangeView },
  props: {
    // 交換者で絞る場合、人物IDと交換者IDが必要
    sidPerson: { type: [String, Number], required: true },
    userId: { type: [String, Number], required: true }
    // // TODO 名刺で絞る場合、名刺IDだけでOK？
    // bcardId: { type: Number, required: false, default: null }
  },
  data () {
    return {
      isLoading: true,
      list: [],
      pagination: {},

      modalEdit: {
        isOpen: false,
        value: {},
        isExec: false
      },

      modalDelete: {
        isOpen: false,
        id: null,
        isExec: false
      }
    }
  },
  computed: {
    bootstrapRowCount () {
      return Math.ceil(this.list.length / 3)
    }
  },
  watch: {
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.bcardListReloader' (bcardListReloader) {
      if (bcardListReloader) {
        this.getListByUser(this.userId)
      }
    },
    userId (newval, oldval) {
      if (newval !== oldval) {
        this.getListByUser(newval)
      }
    }
  },
  created () {
    if (this.userId) {
      this.getListByUser(this.userId)
    }
    // else if (this.bcardId) {
    //   this.getListByBcard(this.bcardId)
    // }
  },
  methods: {
    editable (item) {
      // 機能管理者または所有者
      return this.isMgmt || item.sid_user === this.$store.getState('login_user').id
    },
    deletable (item) {
      return this.editable(item)
    },
    getListByUser (userId) {
      const vm = this
      const sidPerson = this.sidPerson

      this.isLoading = true
      ExchangeRepository.getListByUser(sidPerson, userId, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response)
          vm.list = data.data
          // vm.pagination = data.pagination
          // vm.informationCount = vm.pagination.count
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || 'この交換者の名刺交換履歴を取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
        .finally(function () {
          vm.isLoading = false
        })
    },
    // getListByBcard (bcardId) {
    //   this.list = [
    //     {
    //       'sid_person': 103,
    //       'id': 103,
    //       'full_name': '大森 圭介',
    //       'last_kana': 'オオモリ',
    //       'first_kana': 'ケイスケ',
    //       'corporate_name': '株式会社RRRコンピューターサービス',
    //       'corporate_kana': 'あーるあーるあーる',
    //       'dept': '公共情報事業本部',
    //       'post': '主任心得',
    //       'formatted_exdate': '2017/01/01',
    //       'mock_exchanger_name': '山田太郎',
    //       'is_latest': bcardId === 101 ? '1' : '0'
    //     },
    //     {
    //       'sid_person': 113,
    //       'id': 113,
    //       'full_name': '大森 圭介',
    //       'last_kana': 'オオモリ',
    //       'first_kana': 'ケイスケ',
    //       'corporate_name': '株式会社RRRコンピューターサービス',
    //       'corporate_kana': 'あーるあーるあーる',
    //       'dept': '公共情報事業本部',
    //       'post': '主任心得',
    //       'formatted_exdate': '2017/01/01',
    //       'mock_exchanger_name': '山田太郎',
    //       'is_latest': bcardId === 101 ? '1' : '0'
    //     }
    //   ]
    // },
    getBootstrapSplittedList (rownum) {
      const start = (rownum - 1) * COL_COUNT
      return this.list.slice(start, start + COL_COUNT)
    },
    getBootstrapRealIndex (rownum, index) {
      return (rownum - 1) * COL_COUNT + index
    },
    openEdit (item) {
      this.modalEdit.isOpen = true
      this.modalEdit.value = Object.assign({}, item) // 参照コピーではなく値コピー
    },
    openDelete (item) {
      this.modalDelete.isOpen = true
      this.modalDelete.id = item.id
    },
    submitDelete () {
      const vm = this

      this.modalDelete.isExec = true
      ExchangeRepository.delete(this.modalDelete.id, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.reloadData()
            vm.showToast('名刺交換履歴を削除しました。', { type: 'success' })
            vm.modalDelete.isOpen = false
            vm.$emit('delete', vm.list.length - 1)
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺交換履歴を削除できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
        .finally(function () {
          vm.modalDelete.isExec = false
        })
    },
    submitEdit () {
      const vm = this

      const data = this.modalEdit.value
      const params = {
        'ex_location': data.ex_location,
        'ex_location_detail': data.ex_location_detail,
        'ex_trigger': data.ex_trigger,
        'ex_trigger_detail': data.ex_trigger_detail,
        'in_introducer': data.inner_introducer ? data.inner_introducer.id : null,
        'out_introducer': data.outer_introducer ? data.outer_introducer.id : null,
        'feature': data.feature,
        'age': data.age,
        'comment': data.comment,
        'exchange_date': data.exchange_date
      }

      this.modalEdit.isExec = true
      ExchangeRepository.put(data.id, params, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.reloadData()
            vm.showToast('名刺交換履歴を変更しました。', { type: 'success' })
            vm.modalEdit.isOpen = false
            vm.$store.dispatch('reloadBcardList')
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺交換履歴を変更できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
        .finally(function () {
          vm.modalEdit.isExec = false
        })
    },
    reloadData () {
      if (this.userId) {
        this.getListByUser(this.userId)
      }
      // else if (this.bcardId) {
      //   this.getListByBcard(this.bcardId)
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/lists/ExchangeHistoryList.vue